<app-header></app-header>
<section class="main-section animate__animated animate__fadeIn">
  <router-outlet></router-outlet>
  <app-filter></app-filter>
</section>
